import { render } from "./IndexNavbar.vue?vue&type=template&id=4002487c"
import script from "./IndexNavbar.vue?vue&type=script&lang=js"
export * from "./IndexNavbar.vue?vue&type=script&lang=js"
script.render = render

export default script